import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { PROCESS } from "@/data/content";

const PROCESS_IMG = "https://images.unsplash.com/photo-1763405739542-02991ab5416c";

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="process" data-testid="process" ref={ref} className="relative overflow-hidden border-y border-white/10">
      <motion.div style={{ y: imgY }} className="absolute inset-0 scale-125">
        <img src={PROCESS_IMG} alt="Construction cranes at dusk" className="w-full h-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 bg-[#050505]/88" />

      <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-12 py-28 md:py-40">
        <Reveal className="mb-20 md:mb-28 max-w-3xl">
          <p className="overline text-[#d4af37] mb-6">The Owner’s Rep Workflow</p>
          <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1.02] tracking-tight text-white">
            A disciplined path from idea to a delivered, defensible asset.
          </h2>
        </Reveal>

        <div className="relative border-l border-white/15 ml-2 md:ml-4">
          {PROCESS.map((step, i) => (
            <Reveal key={step.no} delay={i * 0.06}>
              <div className="relative pl-8 md:pl-16 pb-14 md:pb-20 last:pb-0">
                <span className="absolute -left-[7px] top-2 h-3 w-3 rounded-full bg-[#d4af37]" />
                <div className="grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-8 items-baseline">
                  <span className="md:col-span-1 font-serif text-4xl text-white/20">{step.no}</span>
                  <h3 className="md:col-span-4 font-serif text-2xl md:text-3xl text-white">{step.title}</h3>
                  <p className="md:col-span-6 text-white/60 font-light leading-relaxed">{step.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
